"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
const CleanState = (type, params, keyPrefix) => {
  switch (type) {
    case 'save':
      {
        const decoded = decodeURIComponent(params.get(keyPrefix));
        const paramsParsed = JSON.parse(decoded);
        for (const [key, value] of Object.entries(paramsParsed)) {
          params.set(`${keyPrefix}_${key}`, value);
        }
        params.delete(keyPrefix);
        return params;
      }
    case 'load':
      {
        const newState = {};
        params.forEach((value, key) => {
          if (key.startsWith(`${keyPrefix}_`)) {
            const newKey = key.replace(`${keyPrefix}_`, '');
            newState[newKey] = value;
          }
        });
        return JSON.stringify(newState);
      }
    default:
      return params;
  }
};
export function saveState({
  key,
  state,
  storageType,
  uniqueId
}) {
  if (storageType === 'LOCAL_STORAGE') {
    localStorage.setItem(`${uniqueId}-${key}`, JSON.stringify(state));
  } else if (storageType === 'URL') {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // Preserve other URL parameters
    params.set(key, JSON.stringify(state));
    const paramsPrefix = CleanState('save', params, key);
    url.search = paramsPrefix.toString();
    window.history.pushState({}, '', url.toString());
  }
}
export function loadState({
  key,
  storageType,
  uniqueId
}) {
  if (storageType === 'LOCAL_STORAGE') {
    if (typeof localStorage === 'undefined') {
      return {};
    }
    const savedState = localStorage.getItem(`${uniqueId}-${key}`);
    return savedState ? JSON.parse(savedState) : null;
  }
  if (storageType === 'URL') {
    const url = new URL(window.location.href);
    const savedState = CleanState('load', url.searchParams, key);
    return savedState ? JSON.parse(savedState) : null;
  }
  return null;
}